import { FC, ReactNode } from "react";
import { Outlet } from "react-router-dom";

interface IBaseLayoutProps {
  children?: ReactNode;
}
const BaseLayout: FC<IBaseLayoutProps> = ({ children }) => {
  return <>{children || <Outlet />}</>;
};

export default BaseLayout;
